import React, { useState, useEffect } from 'react';

interface OpenAiOptionsProps {
  settings: any;
  onSettingChange: (key: string, value: string) => void;
}

export const OpenAiOptions: React.FC<OpenAiOptionsProps> = ({ settings, onSettingChange }) => {
  const [inputValue, setInputValue] = useState(settings?.OpenAiKey || '');
  const [apiKey, setApiKey] = useState(settings?.OpenAiKey || '');
  const [groupedModels, setGroupedModels] = useState<Record<string, any[]>>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function findCustomModels() {
      if (!apiKey || apiKey.length < 10) {
        setGroupedModels({});
        return;
      }

      setLoading(true);
      try {
        // Mock para simular busca de modelos - em produção seria uma chamada real à API
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Simular modelos disponíveis
        const mockModels = [
          { id: 'gpt-4o', name: 'GPT-4o', organization: 'OpenAI' },
          { id: 'gpt-4o-mini', name: 'GPT-4o Mini', organization: 'OpenAI' },
          { id: 'gpt-4-turbo', name: 'GPT-4 Turbo', organization: 'OpenAI' },
          { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo', organization: 'OpenAI' }
        ];

        const modelsByOrganization = mockModels.reduce((acc, model) => {
          acc[model.organization] = acc[model.organization] || [];
          acc[model.organization].push(model);
          return acc;
        }, {} as Record<string, any[]>);
        
        setGroupedModels(modelsByOrganization);
      } catch (error) {
        console.error('Erro ao buscar modelos:', error);
        setGroupedModels({});
      } finally {
        setLoading(false);
      }
    }

    findCustomModels();
  }, [apiKey]);

  const handleApiKeyChange = (value: string) => {
    setInputValue(value);
    onSettingChange('OpenAiKey', value);
  };

  const handleApiKeyBlur = () => {
    setApiKey(inputValue);
  };

  const handleModelChange = (value: string) => {
    onSettingChange('OpenAiModelPref', value);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            API Key
          </label>
          <input
            type="password"
            value={inputValue}
            onChange={(e) => handleApiKeyChange(e.target.value)}
            onBlur={handleApiKeyBlur}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="sk-..."
            required
          />
          <p className="text-xs text-gray-500 mt-1">
            Sua chave de API da OpenAI
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Seleção do Modelo de Chat
          </label>
          {loading ? (
            <select
              disabled
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-500"
            >
              <option>Carregando modelos disponíveis...</option>
            </select>
          ) : (
            <select
              value={settings?.OpenAiModelPref || ''}
              onChange={(e) => handleModelChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Selecione um modelo</option>
              {Object.keys(groupedModels)
                .sort()
                .map((organization) => (
                  <optgroup key={organization} label={organization}>
                    {groupedModels[organization].map((model) => (
                      <option key={model.id} value={model.id}>
                        {model.name}
                      </option>
                    ))}
                  </optgroup>
                ))}
            </select>
          )}
          <p className="text-xs text-gray-500 mt-1">
            Selecione o modelo GPT que deseja usar
          </p>
        </div>
      </div>
    </div>
  );
};



